module.exports = __webpack_public_path__ + "img/character_9.b123bffb.svg";